module.exports = __webpack_public_path__ + "img/small.de0293a8.png";